(() => {
  const root = document.documentElement;

  const headerComponent = document.getElementById("header-component");

  const setHeaderVars = () => {
    if (!headerComponent) return;
    const h = Math.ceil(headerComponent.getBoundingClientRect().height || 0);
    if (h > 0) {
      // Vars que o próprio Horizon usa
      document.body.style.setProperty("--header-height", `${h}px`);
      document.body.style.setProperty("--header-group-height", `${h}px`);
      // Var que a gente pode usar em outras correções se precisar
      root.style.setProperty("--shopizi-mobile-header-h", `${h}px`);
    }
  };

  const onScroll = () => {
    if (window.scrollY > 10) root.classList.add("shopizi-scrolled");
    else root.classList.remove("shopizi-scrolled");
  };

  setHeaderVars();
  onScroll();

  window.addEventListener("resize", setHeaderVars, { passive: true });
  window.addEventListener("scroll", onScroll, { passive: true });

  // Theme editor
  document.addEventListener("shopify:section:load", setHeaderVars);
})();
